import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import { TrackEventsRequestBody } from '../transports/tracking-transport'

class TrackingClient {
    public trackFilterRegionNode(regionNodeId: string, body: any): Promise<BaseTransport<void>> {
        return NetworkService.post({
            url: `/api/tracking/v1/filters/${regionNodeId}`,
            body: { filtersTracking: body },
        })
    }

    public trackRegionLandingPageListings(body: any): Promise<BaseTransport<void>> {
        return NetworkService.post({
            url: `/api/tracking/v1/region-landing-page`,
            body: { trackingEvents: body },
        })
    }

    public trackEvents(body: TrackEventsRequestBody): Promise<BaseTransport<void>> {
        return NetworkService.post({
            url: `/api/tracking/v1/track-events`,
            body: body,
        })
    }

    public trackEventsV2(body: TrackEventsRequestBody): Promise<BaseTransport<void>> {
        return NetworkService.post({
            url: `/api/tracking/v2/track-events`,
            body: body,
        })
    }
}

export default new TrackingClient()
